import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types'
import useUserActions from 'hook/useUserActions';
import { useQuery } from 'react-query';
import { format } from 'date-fns';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
};

const BarChart = ({ data }) => {
    return (
        <Bar options={options} data={data || { labels: [], datasets: [] }} />
    );
}

export default BarChart;
BarChart.propTypes = {
    data: PropTypes.object,
}
